// Mock external ingestion events — simulating drafts arriving from Claude/Codex/n8n/webhook/MCP
export const mockInboxEvents = [
  {
    id: "ing_001",
    source: "claude",
    title: "Thread idea: 'Why every operator needs a private skill file'",
    platform: "x",
    asset_type: "thread",
    status: "inbox",
    received_at: "2026-01-22T15:14:00Z",
    preview: "1/ A skill file is the smallest unit of reusable agent capability...",
    payload: {
      origin: "claude.desktop",
      run_id: "clde_8a1c",
      author: "Adam (via Claude)",
      tokens_in: 1840,
    },
  },
  {
    id: "ing_002",
    source: "codex",
    title: "LinkedIn post draft — 'My agent stack in Jan 2026'",
    platform: "linkedin",
    asset_type: "social_post",
    status: "needs_review",
    received_at: "2026-01-22T13:01:00Z",
    preview: "My current stack: Anthropic for writing, OpenAI for critique, Ollama local for embeddings...",
    payload: {
      origin: "codex.cli",
      template: "linkedin_authority",
      author: "Adam (via Codex)",
    },
  },
  {
    id: "ing_003",
    source: "n8n",
    title: "Repurpose batch — 'AI content systems' blog (7 cuts)",
    platform: "linkedin",
    asset_type: "imported_draft",
    status: "inbox",
    received_at: "2026-01-22T11:42:00Z",
    preview: "Cut 1/7: SMBs don't need 'an AI strategy'. They need one workflow that compounds.",
    payload: {
      origin: "n8n.workflow.repurpose-blog",
      asset_count: 7,
      source_url: "adamdoes.ai/blog/ai-content-systems",
    },
  },
  {
    id: "ing_004",
    source: "webhook",
    title: "YouTube comment harvest — 'voice agent' search",
    platform: "x",
    asset_type: "imported_draft",
    status: "archived",
    received_at: "2026-01-21T22:00:00Z",
    preview: "\"Does this work for after hours appointments only or all day?\" — viewer question, good thread idea.",
    payload: {
      origin: "webhook.youtube-harvest",
      query: "voice agent",
      results: 14,
    },
  },
  {
    id: "ing_005",
    source: "openclaw",
    title: "Image prompt batch — cover art for Codex Skills series",
    platform: "linkedin",
    asset_type: "image_prompt",
    status: "inbox",
    received_at: "2026-01-21T19:30:00Z",
    preview: "Editorial dark studio, single illuminated cube etched with abstract glyphs...",
    payload: {
      origin: "openclaw.runner",
      model: "flux-1.1",
      style: "editorial-dark",
    },
  },
  {
    id: "ing_006",
    source: "hermes",
    title: "Hermes research summary — 'agent skill maintenance trends'",
    platform: "blog",
    asset_type: "research_brief",
    status: "inbox",
    received_at: "2026-01-21T16:18:00Z",
    preview: "Across 14 sources scanned, 'skill drift' is emerging as the dominant production failure mode...",
    payload: {
      origin: "hermes.research",
      sources_scanned: 14,
      sources_kept: 6,
    },
  },
  {
    id: "ing_007",
    source: "mcp_server",
    title: "MCP-routed asset — 'Voice agent ROI calculator' Loom",
    platform: "linkedin",
    asset_type: "video_script",
    status: "inbox",
    received_at: "2026-01-21T12:02:00Z",
    preview: "Loom recording transcript: 'Let me walk you through how to calculate ROI for an HVAC voice agent...'",
    payload: {
      origin: "mcp.social-content-engine",
      duration_sec: 312,
    },
  },
];

export const mockIngestionEndpoint = {
  webhook_url: "https://social-content-engine.example.com/ingest/v1/8e2-a9b1-44d2",
  api_key_masked: "sk_adams_*****_7c4f",
  api_key_status: "active",
  last_received_at: "2026-01-22T15:14:00Z",
  last_payload_summary: { source: "claude", asset_type: "thread", platform: "x" },
  sample_payload: {
    source: "claude",
    title: "Thread idea",
    platform: "x",
    asset_type: "thread",
    body: "1/ ...",
    metadata: { author: "adam", run_id: "abc" },
  },
};
